import {
  openPrintWindow,
  buildPrint,
  fmtDate,
  fmtNum,
} from './printHelper';
import { buildSaleInvoicePrintHtml } from './saleInvoicePrint';

export { openPrintWindow };
export { buildSaleInvoicePrintHtml };

// Helpers to feed the ERP tenant's Business record into the (supply-chain
// style) print builders.
const logoDataUrl = (logo) => {
  if (!logo) return '';
  return String(logo).startsWith('data:') ? String(logo) : `data:image/png;base64,${String(logo)}`;
};

export function erpBusinessToBiz(business = {}) {
  if (!business) return {};
  return {
    nameEn: business.name_en || '',
    nameAr: business.name_ar || business.name_en || '',
    cr: business.cr_no || '',
    vat: business.vat_no || '',
    logo: logoDataUrl(business.logo),
  };
}

export function erpBusinessToSellerSnapshot(business = {}) {
  if (!business) return {};
  return {
    name_en: business.name_en || '',
    name_ar: business.name_ar || business.name_en || '',
    cr_number: business.cr_no || '',
    vat_number: business.vat_no || '',
    tax_number: business.vat_no || '',
    phone: business.contact_info || '',
    email: business.email || '',
    address: business.address || '',
    logo_url: logoDataUrl(business.logo),
  };
}

const esc = (value) => {
  if (value === null || value === undefined || value === '') return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
};
export function buildPurchaseInvoicePrintHtml(inv, biz = {}) {
  const lines = (
    (Array.isArray(inv.lines) && inv.lines.length
      ? inv.lines
      : inv.items) || []
  )

  const grand =
    lines.reduce((sum, l) => {
      const q = Number(l.quantity || 0)
      const p = Number(l.unit_price || 0)
      return (
        sum +
        q *
        p *
        (1 - (Number(l.discount1_pct) || 0) / 100) *
        (1 - (Number(l.discount2_pct) || 0) / 100) *
        (1 + (Number(l.vat_pct) || 0) / 100)
      )
    }, 0) ||
    Number(inv.total_amount || inv.grand_total || 0)

  return buildPrint(
    'Purchase Invoice',
    inv.invoice_number,
    inv.status,
    {
      'Invoice #': inv.invoice_number,
      'Date': fmtDate(inv.invoice_date),
      'Due': fmtDate(inv.payment_due_date),
    },
    [
      {
        label: 'Supplier',
        value:
          inv.supplier_name || inv.supplier_name_ar || inv.supplier_id || '',
      },
      { label: 'Payment Due', value: fmtDate(inv.payment_due_date) },
      { label: 'Payment Terms', value: inv.payment_terms || '90 DAYS' },
      { label: 'Invoice Date', value: fmtDate(inv.invoice_date) },
      { label: 'Currency', value: inv.currency || 'SAR' },
    ],
    {
      headers: [
        { label: '#' },
        { label: 'CODE' },
        { label: 'ITEM' },
        { label: 'UOM', align: 'ctr' },
        { label: 'QTY', align: 'num' },
        { label: 'PRICE', align: 'num' },
        { label: 'DISC', align: 'num' },
        { label: 'VAT', align: 'num' },
        { label: 'BATCH', align: 'num' },
        { label: 'TOTAL', align: 'num' },
      ],
      rows: lines.map(
        (l, idx) => `
        <tr>
          <td>${idx + 1}</td>
          <td>${esc(l.item_code || '')}</td>
          <td>${esc(l.item_name || l.description || '')}</td>
          <td class="ctr">${esc(l.uom_code || l.uom || 'EA')}</td>
          <td class="num">${l.quantity || 1}</td>
          <td class="num">${fmtNum(l.unit_price)}</td>
          <td class="num">${l.discount1_pct ?? 0}%</td>
          <td class="num">${l.vat_pct ?? 0}%</td>
          <td class="num">${esc(l.batch_number)}</td>
          <td class="num">${fmtNum(
          l.line_total ||
          l.total ||
          Number(l.quantity || 0) * Number(l.unit_price || 0),
        )}</td>
        </tr>`,
      ),
      empty: 'No items',
    },
    {
      rows: [
        { label: 'Grand Total', value: fmtNum(grand), grand: true },
      ],
    },
    '',
    [
      { name: 'Prepared By', role: 'AP' },
      { name: 'Approved By', role: 'Finance' },
    ],
    'en',
    biz,
  )
}